exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-source-forms-source-form-for-tax-form-styles__mainContent {\n\tpadding-right: 21rem;\n\tpadding-left: 2.4rem;\n\tmin-width: 1000px;\n}\n", ""]);

// exports
exports.locals = {
	"mainContent": "src-source-forms-source-form-for-tax-form-styles__mainContent"
};